@use "../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../styles/Constants.scss" as Constants;

.CheckboxCell {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;

	&:not(.disabled) {
		background-color: Colors.$col-white;
	}
}
